import { cn } from '@/utils';

export function CfCaptchaWidget({
	id = 'cf-turnstile-widget',
	className,
	...props
}) {
	return (
		<div
			id={id}
			className={cn('mx-auto empty:hidden', className)}
			{...props}
		/>
	);
}
